import React, { FC } from 'react';
import Image from 'next/legacy/image';

import { useTranslation } from 'next-i18next';
import {
  APP_STORE_APPLE, APP_STORE_GOOGLE, NEW_TAB_ATTRIBUTES, NEXT_STATIC_IMAGES,
} from 'src/common/constants';
import useMobileNativeWebView from 'src/common/hooks/useMobileNativeWebView';
import getClassNames from '../../utils/getClassNames';

import styles from './AppLinks.module.scss';

const ASSETS = `${NEXT_STATIC_IMAGES}mobile-apps/`;

export type AppLinksProps = {
  classNameModifier?: string;
  outline?: 'midnight' | 'white';
};

const AppLinks: FC<AppLinksProps> = ({
  classNameModifier,
  outline,
}) => {
  const [t] = useTranslation('common');
  const { isMobileNativeWebView } = useMobileNativeWebView();
  if (isMobileNativeWebView) return null;
  return (
    <ul className={getClassNames(styles, 'root', classNameModifier)}>
      <li>
        <a
          className={getClassNames(styles, 'link', classNameModifier)}
          href={APP_STORE_APPLE}
          title={t('app-links--ios')}
          {...NEW_TAB_ATTRIBUTES}
        >
          <Image
            height={40}
            width={135}
            alt={t('app-links--ios')}
            src={outline ? `${ASSETS}app-store-${outline}.svg` : `${ASSETS}app-store.svg`}
          />
        </a>
      </li>
      <li>
        <a
          className={getClassNames(styles, 'link', classNameModifier)}
          href={APP_STORE_GOOGLE}
          {...NEW_TAB_ATTRIBUTES}
          title={t('app-links--android')}
        >
          <Image
            height={40}
            width={135}
            alt={t('app-links--android')}
            src={outline ? `${ASSETS}google-play-store-${outline}.svg` : `${ASSETS}google-play-store.svg`}
          />
        </a>
      </li>
    </ul>
  );
};

export default AppLinks;
